(ns common.schema.entities.counterparty-diligence.templates.capman.notifications
  "CapMan-specific counterparty-diligence notification definitions.

   Each notification is referenced by id from form templates
   (`templates/capman/legal_entity.cljc` etc.). The notification has one
   `:variants` entry per form-template-id, so subject/body/placeholders/sample
   data can differ between project/company/person diligence — while the
   recipients list is shared across all variants and configured per tenant
   in the settings UI.")

(def review
  {:id          :notification/counterparty-diligence-review
   :label       {:en "Diligence form submitted for review"}
   :description {:en "Sent when a diligence form moves to Review."}
   :variants
   [{:template-id    :counterparty-diligence-template/capman-project
     :label          {:en "Project diligence"}
     :subject        "CapMan KYC | Project diligence submitted for review - {{project-name}}"
     :body
     (str "A Project diligence form has been submitted for review in Zapflow.\n\n"
          "Project: {{project-name}}\n"
          "Fund: {{fund-name}}\n"
          "Responders: {{responder-emails}}\n"
          "Created by: {{process-creator-email}}\n\n"
          "You can review the form in Zapflow.\n\n")
     :placeholders   [{:key :project-name
                       :label {:en "Project name"}}
                      {:key :fund-name
                       :label {:en "Fund name"}}
                      {:key :responder-emails
                       :label {:en "Responder emails"}}
                      {:key :process-creator-email
                       :label {:en "Process creator email"}}]
     :sample-context {:project-name          "Example Project"
                      :fund-name             "Example Fund III"
                      :responder-emails      "alice@example.com, bob@example.com"
                      :process-creator-email "creator@capman.com"}}

    {:template-id    :counterparty-diligence-template/capman-legal-entity
     :label          {:en "Company diligence"}
     :subject        "CapMan KYC | Company diligence submitted for review - {{company-name}}"
     :body
     (str "A Company diligence form has been submitted for review in Zapflow.\n\n"
          "Company: {{company-name}}\n"
          "Responders: {{responder-emails}}\n"
          "Created by: {{process-creator-email}}\n\n"
          "You can review the form in Zapflow.\n\n")
     :placeholders   [{:key :company-name
                       :label {:en "Company name"}}
                      {:key :responder-emails
                       :label {:en "Responder emails"}}
                      {:key :process-creator-email
                       :label {:en "Process creator email"}}]
     :sample-context {:company-name          "Example Holdings Oy"
                      :responder-emails      "alice@example.com"
                      :process-creator-email "creator@capman.com"}}

    {:template-id    :counterparty-diligence-template/capman-natural-person
     :label          {:en "Person diligence"}
     :subject        "CapMan KYC | Person diligence submitted for review - {{person-name}}"
     :body
     (str "A Person diligence form has been submitted for review in Zapflow.\n\n"
          "Person: {{person-name}}\n"
          "Responders: {{responder-emails}}\n"
          "Created by: {{process-creator-email}}\n\n"
          "You can review the form in Zapflow.\n\n")
     :placeholders   [{:key :person-name
                       :label {:en "Person name"}}
                      {:key :responder-emails
                       :label {:en "Responder emails"}}
                      {:key :process-creator-email
                       :label {:en "Process creator email"}}]
     :sample-context {:person-name           "Jane Doe"
                      :responder-emails      "alice@example.com"
                      :process-creator-email "creator@capman.com"}}]})

(def all-notifications [review])
